import { HTMLAttributes } from 'react';
import classnames from 'src/util/classnames';

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  type?: 'border' | 'grow';
  size?: 'sm';
  color?: string;
}

export function Spinner({ type = 'border', size, color, className, children, ...props }: SpinnerProps) {
  return (
    <div role="status" className={classnames(`spinner-${type}`, size && `spinner-${type}-${size}`, color && `text-${color}`, className)} {...props}>
      {children ?? <span className="visually-hidden">Loading...</span>}
    </div>
  );
}
